import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/checkout", {
	title: "Checkout",
	icon: {
		src: <Icon icon="cart" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Checkout.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
